import { DatePicker } from 'rsuite';
import 'rsuite/DatePicker/styles/index.css';
interface IDatePickerInputProps {
  pickerType: string | undefined;
  pageState?: { sortBySingleDate?: string | string[] };
  singleDateChangeHandler?: (date: Date | null) => void;
  selectedDate?: string;
}

const DatePickerInput = ({
  pickerType,
  pageState,
  singleDateChangeHandler,
  selectedDate,
}: IDatePickerInputProps) => {
  return (
    <div>
      <DatePicker
        size="md"
        format={pickerType === 'month' ? 'MM/yyyy' : 'dd/MM/yyyy'}
        placeholder={pickerType === 'month' ? 'Select Month' : 'Select Date'}
        placement="auto"
        defaultValue={selectedDate ? new Date(selectedDate) : undefined}
        value={
          pageState?.sortBySingleDate?.[0]
            ? new Date(pageState.sortBySingleDate[0])
            : undefined
        }
        onChange={(value) => singleDateChangeHandler?.(value)}
        cleanable={false}
        shouldDisableDate={(date) => date && date > new Date()}
        oneTap
      />
    </div>
  );
};

export default DatePickerInput;
